/**
 * URLs de todos los .mp4 que debe precargar /warmup (mismo origen que el bundle).
 * Incluye bg, avatares (vídeos pesados / modales) y videos (presentación, etc.).
 * require.context es estático: estas carpetas deben existir en build (pueden estar vacías de mp4).
 */
function collectMp4Urls() {
	const contexts = [
		require.context("../assets/bg", false, /\.mp4$/i),
		require.context("../assets/avatares", false, /\.mp4$/i),
		require.context("../assets/videos", false, /\.mp4$/i),
	];

	const seen = new Set();
	const out = [];

	for (const ctx of contexts) {
		for (const key of ctx.keys()) {
			const url = ctx(key);
			if (!seen.has(url)) {
				seen.add(url);
				out.push(url);
			}
		}
	}

	return out;
}

const VIDEO_URLS = collectMp4Urls();

export default VIDEO_URLS;
